import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { TooltipStyled } from 'src/components';
import { predefinedTags, randomColorGenerator, cn } from 'src/utils';
import { tagVariants, closeIconVariants, getTagStyle } from './tagVariants';

type Props = {
  tag: string;
  removeTag: (tag: string) => void;
};

export const TempCartTag = ({ tag, removeTag }: Props) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const { t } = useTranslation();
  const lowerCaseTag = tag.toLowerCase();
  const tagStyle = getTagStyle(tag);

  // Determine if this is a predefined tag
  const isPredefinedTag = predefinedTags.some((predefinedTag) =>
    lowerCaseTag.includes(predefinedTag.toLowerCase()),
  );

  // Generate random colors for non-predefined tags
  let lightColor, darkColor;
  if (!isPredefinedTag) {
    [lightColor, darkColor] = randomColorGenerator(lowerCaseTag);
  }

  return (
    <TooltipStyled
      title={t('popup.click_to_remove')}
      enterDelay={200}
      disableInteractive
    >
      <li
        {...(lightColor
          ? {
              style: {
                background: lightColor,
                color: darkColor,
                fill: darkColor,
                ...(isHovered && { border: `1px solid ${darkColor}` }),
              },
              onMouseEnter: () => setIsHovered(true),
              onMouseLeave: () => setIsHovered(false),
            }
          : {})}
        onClick={(e) => {
          e.stopPropagation();
          removeTag(tag);
        }}
        className={cn(tagVariants({ status: tagStyle, variant: 'removable' }))}
      >
        <span className='max-w-[160px] truncate xs:max-w-[240px]'>{tag}</span>
        <div
          id={tag}
          onClick={(e) => {
            e.stopPropagation();
            removeTag(tag);
          }}
          style={{ fill: darkColor }}
          className={cn(closeIconVariants({ status: tagStyle }))}
        >
          <CloseIcon
            className='cursor-pointer transition-all'
            style={{ fontSize: '16px', fill: 'inherit' }}
          />
        </div>
      </li>
    </TooltipStyled>
  );
};
